import React, { Component } from 'react';
import { Spin, Form, Input, Select, InputNumber, message, Button } from 'antd';
import axios from 'axios';
import {Parse} from 'parse';

import { FormattedMessage, FormattedHTMLMessage, defineMessages ,   injectIntl } from 'react-intl';
import '../../../styles/Payouts.css';
import payoutRequest from '../../../utils/payoutRequest';
import _ from 'lodash';

const FormItem = Form.Item;
const Option = Select.Option;

const messages=defineMessages({
  nameRequired:{
    id:'PayoutsForm.form.name.error.required',
    defaultMessage:'Name is required'
  },
  emailRequired:{
    id:'PayoutsForm.form.email.error.required',
    defaultMessage:'Email is required'
  },
  emailType:{
    id:'PayoutsForm.form.email.error.type',
    defaultMessage:'Email is not a valid email'
  },
  accountBankRequired:{
    id:'PayoutsForm.form.accountBank',
    defaultMessage:"Please select a bank"
  },
  BankDefault:{
    id:'PayoutsForm.form.bankDefault',
    defaultMessage:"Bank"
  },
  accountNumber:{
    id:'PayoutsForm.form.accountNumber',
    defaultMessage:"Account number"
  },
  accountNumberRequired:{
    id:'PayoutsForm.form.accountNumber.error.required',
    defaultMessage:"Account number is required"
  },
  accountNumberType:{
    id:'PayoutsForm.form.accountNumber.error.type',
    defaultMessage:"Account number is not a valid Account Number"
  },
  accountName:{
    id:'PayoutsForm.form.accountName',
    defaultMessage:"A deposit"
  },
  accountNameRequired:{
    id:'PayoutsForm.form.accountName.error.required',
    defaultMessage:"A deposit is required"
  },
  taxPaymentCodeRequired:{
    id:'PayoutsForm.vietnam.form.taxPaymentCode.error.required',
    defaultMessage:"Tax payment code is required"
  },
  paymentRequestRequired:{
    id:'PayoutsForm.form.payment.request.error.required',
    defaultMessage:"Payment amount is required"
  },
  paymentRequestType:{
    id:'PayoutsForm.form.payment.request.error.type',
    defaultMessage:"You can apply in dollar increments from the amount of more than $100."
  },
  notMatchEmail:{
    id:'PayoutsForm.form.payment.request.notMatchEmail',
    defaultMessage:"E-mail does not match the one you joined."
  },
  requestFailed:{
    id:'PayoutsForm.form.payment.request.failed',
    defaultMessage:"You have exceeded your credit. Please check it."
  },
  requestMailSuccess:{
    id:'PayoutsForm.form.payment.request.mail.success',
    defaultMessage:"Request Success"
  },
  requestMailError:{
    id:'PayoutsForm.form.payment.request.mail.error',
    defaultMessage:"Error! Please try again"
  },
});

class Vietnam extends Component{

  constructor(props) {
    super(props);
    this.state = { loading : false };
    this._handleRequest = this._handleRequest.bind(this);
    this._handleRequestDebounced= _.debounce(this._handleRequest, 1000);
  }

  componentWillUnmount() {
    this._handleRequestDebounced.cancel();
  }

  render() {
    const { getFieldDecorator, getFieldError} = this.props.form;
    const {formatMessage}=this.props.intl;
      return (
        <Spin spinning={this.state.loading}>
          <p className="headline payoutsform-headline">
            <FormattedMessage
              id="PayoutsForm.vietnam.headline"
              defaultMessage="Remittance Request (VIETNAM)"
            />
          </p>

          <Form className="payoutsform" layout="inline">
            <div className="payoutsform-content-box">
              <span className="payoutsform-input-label">
                <FormattedMessage
                  id={'PayoutsForm.form.name'}
                  defaultMessage={'Name:'}/>
              </span>
              <FormItem validateStatus={getFieldError('name') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                {getFieldDecorator('name', {
                  rules: [
                    { required: true, message: formatMessage(messages.nameRequired) },
                  ],
                })(
                    <Input style={{width:'224px', height:'32px'}}/>
                )}
              </FormItem>
              <span className="payoutsform-explain" style={{margin:'auto 9px'}}>
                <FormattedMessage
                  id={'PayoutsForm.vietnam.form.name.explain'}
                  defaultMessage={'* Enter name of payment recipient'}
                />
              </span>
            </div>
            <div className="payoutsform-content-box">
              <span className="payoutsform-input-label">
                <FormattedMessage
                  id={'PayoutsForm.form.email'}
                  defaultMessage={'E-mail:'}
                />
              </span>
              <FormItem validateStatus={getFieldError('email') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                {getFieldDecorator('email', {
                  rules: [
                    {type:'email', message: formatMessage(messages.emailType) },
                    { required: true, message: formatMessage(messages.emailRequired) },
                  ],

                })(
                  <div>
                    <Input style={{width:'224px', height:'32px'}} />
                    <span className="payoutsform-explain" style={{margin:'auto 9px'}}>
                      <FormattedMessage
                        id={'PayoutsForm.form.email.explain'}
                        defaultMessage={'* Enter subscribed E-mail'}
                      />
                    </span>
                  </div>
                )}
              </FormItem>
            </div>
            <div className="payoutsform-content-box payoutsform-content-outer">
              <div className="payoutsform-input-label payoutsform-content-title">
                <FormattedMessage
                  id={'PayoutsForm.form.account'}
                  defaultMessage={'Account:'}
                />
              </div>
              <div className="payoutsform-content-inner">
                <FormItem validateStatus={getFieldError('accountBank') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                  {getFieldDecorator('accountBank', {
                    rules: [
                      { required: true, message: formatMessage(messages.accountBankRequired) },
                    ],
                  })(
                      <Select placeholder={formatMessage(messages.BankDefault)} style={{ width:'200px' }}>
                        <Option value="VBSP (사회정책은행)">VBSP</Option>
                        <Option value="Viet com Bank (대외무역은행)">Viet com Bank</Option>
                        <Option value="Vietin Bank (산업무역은행)">Vietin Bank</Option>
                        <Option value="BIDV (투자개발은행)">BIDV</Option>
                        <Option value="Agri Bank (농업농촌개발은행)">Agri Bank</Option>
                        <Option value="MHB (메콩델타주택은행)">MHB</Option>
                        <Option value="ACB">ACB</Option>
                        <Option value="Techcom Bank">Techcom Bank</Option>
                        <Option value="Exim Bank">Exim Bank</Option>
                        <Option value="Sacom Bank">Sacom Bank</Option>
                        <Option value="Military Bank">Military Bank</Option>
                        <Option value="Maritime Bank">Maritime Bank</Option>
                        <Option value="SeA Bank">SeA Bank</Option>
                        <Option value="VID Public">VID Public</Option>
                        <Option value="Indovina Bank Ltd">Indovina Bank Ltd</Option>
                        <Option value="Vinasiam Bank">Vinasiam Bank</Option>
                        <Option value="VRB">VRB</Option>
                        <Option value="HSBC">HSBC</Option>
                        <Option value="Standart Chartered">Standart Chartered</Option>
                        <Option value="Shinhan Bank">Shinhan Bank</Option>
                        <Option value="ANZ">ANZ</Option>
                        <Option value="Hong Leong">Hong Leong</Option>
                        <Option value="Woori Bank">Woori Bank</Option>
                        <Option value="KED Hana Bank">KED Hana Bank</Option>
                        <Option value="IBK Bank">IBK Bank</Option>
                        <Option value="KB Bank">KB Bank</Option>
                        <Option value="Busan Bank">Busan Bank</Option>
                        <Option value="Prudential Veitnam">Prudential Veitnam</Option>
                        <Option value="Societe General Viet">Societe General Viet</Option>
                        <Option value="PPF Vietnam">PPF Vietnam</Option>
                        <Option value="Toyota Financial Service Vietnam">Toyota Financial Service Vietnam</Option>
                        <Option value="ANZ/V-TRAC">ANZ/V-TRAC</Option>
                        <Option value="Vietnam Internatinal">Vietnam Internatinal</Option>
                        <Option value="Kexim Vietnam">Kexim Vietnam</Option>
                        <Option value="Chailease International">Chailease International</Option>

                      </Select>
                  )}
                </FormItem>

                <FormItem validateStatus={getFieldError('accountNumber') ? 'error' : ''}>
                  {getFieldDecorator('accountNumber', {
                    rules: [
                      { required: true, message: formatMessage(messages.accountNumberRequired) },
                      { pattern: /[0-9]-?/, message: formatMessage(messages.accountNumberType) },
                    ],

                  })(
                      <Input placeholder={formatMessage(messages.accountNumber)} style={{width:'224px', height:'32px'}} />
                  )}
                </FormItem>
                <FormItem validateStatus={getFieldError('accountName') ? 'error' : ''}>
                  {getFieldDecorator('accountName', {
                    rules: [
                      { required: true, message: formatMessage(messages.accountNameRequired) },
                    ],

                  })(
                      <Input placeholder={formatMessage(messages.accountName)} style={{width:'224px', height:'32px'}} />
                  )}
                </FormItem>
              </div>
            </div>
            <div className="payoutsform-content-box">
              <span className="payoutsform-input-label">
                <FormattedMessage
                  id={'PayoutsForm.vietnam.form.taxPaymentCode'}
                  defaultMessage={'Tax payment code :'}
                />
              </span>

              <FormItem validateStatus={getFieldError('taxPaymentCode') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                {getFieldDecorator('taxPaymentCode', {
                  rules: [
                    { required: true, message: formatMessage(messages.taxPaymentCodeRequired) },
                  ],

                })(
                  <div>
                    <Input style={{width:'224px', height:'32px'}} />
                  </div>
                )}
              </FormItem>
            </div>
            <div className="payoutsform-content-box">
              <span className="payoutsform-input-label">
                <FormattedMessage
                  id={'PayoutsForm.form.payment.amount.request'}
                  defaultMessage={'Payment amount request ($) :'}
                />
              </span>

              <FormItem validateStatus={getFieldError('paymentRequest') ? 'error' : ''} style={{verticalAlign:'middle'}}>
                {getFieldDecorator('paymentRequest', {
                  rules: [
                    { required: true, message: formatMessage(messages.paymentRequestRequired) },
                    { pattern:/^[0-9]*$/, message:formatMessage(messages.paymentRequestType) },
                  ],

                })(
                  <InputNumber max={this.props.credit} placeholder="100" style={{width:'95px', height:'32px'}}/>
                )}
              </FormItem>
              <span className="payoutsform-current-credit">
              <FormattedHTMLMessage
                id="PayoutsForm.form.payment.credit"
                defaultMessage="Remittable Revenue : "
              />
              {this.props.credit}($)
              </span>
            </div>
            <Button className="payouts-request-btn" type="primary" onClick={()=> this.setState({loading: true}, this._handleRequestDebounced)}>
              <FormattedMessage
                id={'PayoutsForm.request.btn'}
                defaultMessage={'Filing for'}
              />
            </Button>
          </Form>
        </Spin>
      )
    }



  _handleRequest(){
    this.props.form.validateFields(async(err, values) => { 
      // mail로 보낼 데이터 formData에 넣어주기
      let formData = new FormData();

      formData.append('userId', Parse.User.current().id);
      formData.append('sessionToken', Parse.User.current().getSessionToken());
      formData.append('신청 방법', 'vietnam');
      formData.append('email', values.email);
      formData.append('은행', values.accountBank);
      formData.append('계좌 번호', values.accountNumber);
      formData.append('예금주', values.accountName);
      formData.append('tax payment code', values.taxPaymentCode);
      formData.append('신청금액', values.paymentRequest);

      const userInfo={
        'name': values.name,
        'email': values.email,
        'accountBank': values.accountBank,
        'accountName': values.accountName,
        'paymentRequest':values.paymentRequest
      };

      const {formatMessage}=this.props.intl;
      const {onCancel}=this.props;
      if(!err){//form 형식에서 에러 안날 시
        //1. 입력한 이메일이 로그인한 유저의 이메일과 같은지 비교하기
        if(values.email !== Parse.User.current().getEmail()){
          message.error(formatMessage(messages.notMatchEmail));
          return;
        }

        //2. 같을 경우 money, payout class에 추가 요청하는 함수 호출
        const payoutRequestResult = await payoutRequest(values.paymentRequest, userInfo,"vietnam");
        if(payoutRequestResult===false)
        {
          message.error(formatMessage(messages.requestFailed));
          this.setState({loading: false});
          onCancel();
        }
        else{
          //payout_manager에게 정산 요청 메일 발송.
          axios.post(process.env.REACT_APP_REQUEST_PAYMENT, formData)
          .then(async(res)=> {
            this.setState({loading : false}, () => {
              message.success(formatMessage(messages.requestMailSuccess));
              onCancel();//모달 닫기
            });
          }).catch(function(error) {
            console.log(error);
            message.error(formatMessage(messages.requestMailError));
            this.setState({loading: false});
            onCancel();
          });
        }

      }else{
        this.setState({loading: false})
      }

    })//validateFields end
  }//_handleRequest end

}//end class
  
Vietnam=Form.create({})(injectIntl(Vietnam));



export default Vietnam;
